<template>
  <div v-if="isFetchProduct">
    <ProductForm
      @saveDetail="updateProduct"
      :productDetail="productDetail"
      :update="true"
    />
  </div>
</template>

<script>
import ProductForm from './ProductForm.vue';
import { mapActions } from 'vuex';
export default {
  name: 'EditProduct',
  data: () => ({
    productId: '',
    productDetail: {
      name: '',
      unit: '',
      price: 0,
      sku: null,
      applicableAreas: [],
      treatmentType: {},
      ingredients: '',
      treatmentTiming: '',
      timingOverride: false,
      brandId: '',
      description: '',
      aftercaretemplate: null,
      methods: [],
      defaultLowBalanceAmount: 0,
      treatmentProducts: [],
    },
    isFetchProduct: false,
  }),

  components: { ProductForm },
  async created() {
    this.productId = this.$route.params.productId;
    await this.fetchProduct(this.productId);
  },
  methods: {
    ...mapActions('product', ['fetchProductDetail', 'updateProductDetails']),
    fetchProduct(productId) {
      let self = this;
      this.fetchProductDetail(productId).then((res) => {
        self.productDetail = res.data.data;
        let tempProducts = res.data.data.treatmentProducts &&
        res.data.data.treatmentProducts.map((val) => {
          return val.productStoreId;
        });
        self.productDetail.treatmentProducts = tempProducts;
        
        // Normalize applicableAreas - ensure it's an array of strings
        if (self.productDetail.applicableAreas && Array.isArray(self.productDetail.applicableAreas)) {
          self.productDetail.applicableAreas = self.productDetail.applicableAreas.map((area) => {
            return typeof area === 'string' ? area : (area.name || area);
          });
        } else {
          self.productDetail.applicableAreas = [];
        }
        
        self.isFetchProduct = true;
      });
    },
    updateProduct(prod, selectedTreatmentType, treatmentOptions = []) {
      let self = this;
      this.productDetail.treatmentType = selectedTreatmentType;
      this.productDetail.brandId = prod.brandId;
      this.productDetail.applicableAreas = prod.applicableAreas;
      this.productDetail.ingredients = prod.ingredients;
      this.productDetail.treatmentTiming = prod.treatmentTiming;
      this.productDetail.timingOverride = prod.timingOverride;
      this.productDetail.defaultLowBalanceAmount = prod.defaultLowBalanceAmount;
      this.productDetail.unit = prod.unit;
      this.productDetail.name = prod.name;
      this.productDetail.description = prod.description;
      this.productDetail.aftercaretemplate = prod.aftercaretemplate;
      this.productDetail.methods = prod.methods ? prod.methods.filter(method => method != null) : [];
      this.$vs.loading();
      
      // Exclude MongoDB metadata and unnecessary fields from payload
      // eslint-disable-next-line no-unused-vars
      const { createdAt, updatedAt, __v, ingredients, price, compareAtPrice, quantity, productType, visibleTo, deleted, manufacturedDate, expiryDate, clinicId, categoryId, supplierId, nurses, image, variants, treatmentProducts, ...productPayload } = this.productDetail;
      
      // Convert methods to array of IDs
      if (productPayload.methods && Array.isArray(productPayload.methods)) {
        productPayload.methods = productPayload.methods
          .filter(method => method != null)
          .map(method => typeof method === 'object' ? method.id : method);
      }
      
      this.updateProductDetails({
        id: this.productId,
        info: productPayload,
      }).then(() => {
        self.$vs.notify({
          title: 'Product Update',
          text: 'Product Detail updated successfully',
          color: 'success',
        });
        self.$vs.loading.close();

        const seletectedTreatment = treatmentOptions.filter(
          ({ _id }) => _id === selectedTreatmentType
        );
        this.productDetail.treatmentType = seletectedTreatment[0];
      });
    },
  },
};
</script>

<style scoped></style>
